'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayOnExitIntent = exports.getDisplayOnTimeDelay = exports.getDisplayOnScrollPercentage = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _clientTriggersKeyPaths = require('../constants/clientTriggersKeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDisplayOnScrollPercentage = exports.getDisplayOnScrollPercentage = (0, _getIn2.default)(_clientTriggersKeyPaths.DISPLAY_ON_SCROLL_PERCENTAGE);

var getDisplayOnTimeDelay = exports.getDisplayOnTimeDelay = (0, _getIn2.default)(_clientTriggersKeyPaths.DISPLAY_ON_TIME_DELAY);

var getDisplayOnExitIntent = exports.getDisplayOnExitIntent = (0, _getIn2.default)(_clientTriggersKeyPaths.DISPLAY_ON_EXIT_INTENT);